var _defs, _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack400({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 5.45,
    cy: 8,
    rx: 5.12,
    ry: 5.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.34,10V5.84H3.53a2.31,2.31,0,0,1,.67.07,1.17,1.17,0,0,1,.52.37A1.84,1.84,0,0,1,5.06,7a3.05,3.05,0,0,1,.13,1A3.09,3.09,0,0,1,5,9.12a1.51,1.51,0,0,1-.54.71,1.56,1.56,0,0,1-.86.21Zm.45-.5h.74a1.23,1.23,0,0,0,.67-.15.89.89,0,0,0,.35-.46,2.83,2.83,0,0,0,.17-1,2.34,2.34,0,0,0-.18-1,.91.91,0,0,0-.44-.48,1.4,1.4,0,0,0-.58-.09H2.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.27,8.56l.45.14a1.9,1.9,0,0,1-.53,1.06,1.32,1.32,0,0,1-.92.35,1.39,1.39,0,0,1-.82-.24,1.54,1.54,0,0,1-.55-.75,3,3,0,0,1-.22-1.21A2.76,2.76,0,0,1,5.9,6.73,1.63,1.63,0,0,1,6.48,6a1.42,1.42,0,0,1,.83-.25,1.31,1.31,0,0,1,.86.31,1.78,1.78,0,0,1,.5.91l-.45.13c-.15-.58-.46-.87-.92-.87a1.08,1.08,0,0,0-.6.17A1.18,1.18,0,0,0,6.3,7a2.59,2.59,0,0,0-.15,1,2.28,2.28,0,0,0,.3,1.29.94.94,0,0,0,.81.43.9.9,0,0,0,.64-.26A1.53,1.53,0,0,0,8.27,8.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.15,10V5.84h1.29a1.34,1.34,0,0,1,.62.12.93.93,0,0,1,.38.38,1.1,1.1,0,0,1,.14.57,1.14,1.14,0,0,1-.12.52,1,1,0,0,1-.36.37,1,1,0,0,1,.48.37,1.21,1.21,0,0,1,.17.65,1.35,1.35,0,0,1-.16.67.88.88,0,0,1-.42.41,1.54,1.54,0,0,1-.71.14ZM13.6,7.6h.75a1.35,1.35,0,0,0,.41,0,.58.58,0,0,0,.28-.2A.73.73,0,0,0,15.13,7a.7.7,0,0,0-.08-.37.51.51,0,0,0-.23-.21,1.62,1.62,0,0,0-.53-.06H13.6Zm0,1.94h.86a1.4,1.4,0,0,0,.42,0,.57.57,0,0,0,.3-.25.87.87,0,0,0,.1-.42.76.76,0,0,0-.1-.41.55.55,0,0,0-.26-.24,1.34,1.34,0,0,0-.52-.07h-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack400);
export default __webpack_public_path__ + "static/media/Symbol_pack_400.dd2c3c1df7c6de6914341bdbd2a961d6.svg";
export { ForwardRef as ReactComponent };